var result = require("!!../../../../node_modules/html-loader/index.js?interpolate!./styling_borders_colors.html")
var H = require("hogan.js");
window.Hogan = H;
module.exports = function() {
var T = H.compile(result, {});
return T.render.apply(T, arguments); };


//////////////////
// WEBPACK FOOTER
// ./node_modules/mustache-loader!./node_modules/html-loader?interpolate!./src/components/guideline/templates/styling_borders_colors.html
// module id = 63
// module chunks = 0